var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSocialAds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.4989 9.28675C18.3727 13.1164 19.672 18.5134 14.0585 18.3996C11.8131 18.526 9.55503 18.5766 7.297 18.526C3.94148 18.4881 -0.170925 18.6271 0.00568097 14.0897C0.00568097 10.7908 0.00568097 7.49197 0.00568097 4.19313C-0.107852 2.14557 1.49422 0.274963 3.56304 0.199127C6.04814 0.0348171 8.54585 -0.0410184 11.031 0.0221778C19.3062 -0.18005 18.5493 2.19613 18.4989 9.28675Z",
    fill: "#ABEBD1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 31",
    cx: 4.5,
    cy: 10.5,
    rx: 1.5,
    ry: 1.5,
    transform: "rotate(-90 4.5 10.5)",
    fill: "url(#paint0_linear_30_1256)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 32",
    cx: 8,
    cy: 10,
    rx: 2,
    ry: 2,
    transform: "rotate(-90 8 10)",
    fill: "url(#paint1_linear_30_1256)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    cx: 12.5,
    cy: 9.5,
    r: 2.5,
    transform: "rotate(-90 12.5 9.5)",
    fill: "url(#paint2_linear_30_1256)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30_1256",
    x1: 4.5,
    y1: 9,
    x2: 4.5,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEFFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEFFEB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_30_1256",
    x1: 8,
    y1: 8,
    x2: 8,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEFFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEFFEB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_30_1256",
    x1: 12.5,
    y1: 7,
    x2: 12.5,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEFFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEFFEB",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialAds);
export default __webpack_public_path__ + "static/media/IconSocialAds.327c6e97ae88085ee1c3d812200459b9.svg";
export { ForwardRef as ReactComponent };